import { atom } from "jotai";
import type { AdminEmailMailboxStatus } from "../models/admin-email.models";

// Share only mailbox counts between the sidebar and reader.
// Message subjects and bodies stay in the mounted reader and never enter persistent browser storage.
export const adminEmailMailboxStatusAtom = atom<AdminEmailMailboxStatus>({
  accountId: null,
  response: null,
  loading: false,
  error: null,
});

export const adminEmailMailboxRefreshAtom = atom(0);
